import { render, staticRenderFns } from "./tm-bill.vue?vue&type=template&id=98457ba6&scoped=true&"
import script from "./tm-bill.vue?vue&type=script&lang=ts&"
export * from "./tm-bill.vue?vue&type=script&lang=ts&"
import style0 from "./tm-bill.vue?vue&type=style&index=0&id=98457ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98457ba6",
  null
  
)

export default component.exports